export const IMPERSONATION_TOKEN_KEY = 'impersonationToken';
export const IMPERSONATION_EMAIL_KEY = 'impersonationEmail';
export const IMPERSONATION_BODY_CLASS = 'impersonating';
export const IMPERSONATION_BODY_ATTR = 'data-impersonation';

interface ImpersonationUserState {
  impersonation?: {
    active?: boolean;
    impersonatedUser?: {
      email?: string | null;
    } | null;
  } | null;
  prs?: {
    email?: string | null;
  } | null;
}

export interface ImpersonationContext {
  active: boolean;
  email: string;
}

export function isImpersonationActive(
  userState: unknown,
  sessionToken: string | null
): boolean {
  const state = userState as ImpersonationUserState | null;
  return state?.impersonation?.active === true || Boolean(sessionToken);
}

export function resolveImpersonationContext(
  userState: unknown,
  sessionToken: string | null,
  sessionEmail: string | null
): ImpersonationContext {
  const state = userState as ImpersonationUserState | null;
  const active = isImpersonationActive(state, sessionToken);

  if (!active) {
    return { active: false, email: '' };
  }

  const email =
    state?.impersonation?.impersonatedUser?.email?.trim?.() ||
    sessionEmail?.trim?.() ||
    state?.prs?.email?.trim?.() ||
    '';

  return { active, email };
}

export function setImpersonationDomState(
  document: Document,
  active: boolean
): void {
  document.body.classList.toggle(IMPERSONATION_BODY_CLASS, active);

  if (active) {
    document.body.setAttribute(IMPERSONATION_BODY_ATTR, 'true');
    return;
  }

  document.body.removeAttribute(IMPERSONATION_BODY_ATTR);
}
